import { invert } from 'lodash';
import scssData from 'util/dom/scss-data';


/**
 * The elements to which the mq data are bound
 */
const ROOT_SELECTOR = '.u-mq-spy';
const $dataBridgeMqType = document.querySelector(`${ ROOT_SELECTOR }-type`);
const $dataBridgeMqConditions = document.querySelector(`${ ROOT_SELECTOR }-conditions`);

/**
 * Parses, edits and return the current mq data object
 * @return {Object} - A viewport description object
 */
export function getViewportData() {
    let result = scssData($dataBridgeMqConditions);

    result.width = toNumeral(result.width);
    result.query = toLiteral(result.width);
    result.type = scssData($dataBridgeMqType);

    return result;
}

/**
 * Utility method to switch from literals to numerals and vice versa
 * @param {Object} from - The source of the translation
 * @param {Object} to - The target of the translation
 * @param {number|string} value - The source value to be translated
 * @return {string|number} - A literal or numeral viewport width descriptor
 */
function translateValue(from, to, value) {
    return from[invert(to)[value]];
}

/**
 * Literal values for width media features
 * Useful to access the current config out of an object that has viewport width descriptors as keys
 */
export const literals = Object.freeze({
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
    XXL: 'xxl',
});

/**
 * Numeral values for width media features
 * Useful to compare a desired viewport width state with the current one
 */
export const numerals = Object.freeze({
    XS: 1,
    SM: 2,
    MD: 3,
    LG: 4,
    XL: 5,
    XXL: 6,
});

/**
 * Returns the literal value when given a numeral one
 * @param {number} value - A literal viewport width descriptor
 * @return {string} - The corresponding descriptor as number
 */
export function toLiteral(value) {
    return translateValue(literals, numerals, value);
}

/**
 * Returns the numeral value when given a literal one
 * @param {string} value - A numeral viewport width descriptor
 * @return {number} - The corresponding descriptor as string
 */
export function toNumeral(value) {
    return translateValue(numerals, literals, value);
}



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/util/dom/mq.js